export default __webpack_public_path__ + "static/media/iphone-642999_1920.7d5db27d.jpg";